<template>
    <div v-loading.fullscreen="loading">
        <div v-if="!loading">
            <el-breadcrumb
                v-if="hasRoleToReadLogs"
                style="float: right"
                separator-class="el-icon-arrow-right"
            >
                <el-breadcrumb-item :to="{ path: '/' }">{{$t('route.home')}}</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ name: 'tournamentList' }">{{$t('entities.tournament.plural')}}</el-breadcrumb-item>
                <el-breadcrumb-item>{{ model.name }}</el-breadcrumb-item>

            </el-breadcrumb>

            <h2 class="page-title">{{$t('entities.tournament.singular')}}</h2>

            <el-row :gutter="20">
                <!-- Left -->
                <el-col :span="8">
                    <el-form
                        :label-position="labelPosition"
                        :label-width="labelWidth"
                        :class="{ show: true, 'show-mobile': isMobile }"
                        v-on:submit.native.prevent
                    >
                        <el-form-item v-if="hasRoleToReadLogs" label="Id">{{ model.id }}</el-form-item>

                        <el-form-item :label="$t('entities.tournament.prop.name')">{{ model.name }}</el-form-item>

                        <el-form-item :label="$t('entities.tournament.prop.category')">
                            <app-entity-link entityName="category" :property="model.category"></app-entity-link>
                        </el-form-item>

                        <el-form-item :label="$t('entities.club.singular')">{{ model.club.name }}</el-form-item>

                        <el-form-item
                            v-if="hasRoleToReadLogs"
                            :label="$t('entities.tournament.prop.locality')"
                        >{{ model.locality }}</el-form-item>

                        <el-form-item
                            v-if="hasRoleToReadLogs"
                            :label="$t('entities.tournament.prop.country')"
                        >{{ model.country }}</el-form-item>

                        <el-form-item
                            v-if="hasRoleToReadLogs"
                            :label="$t('entities.tournament.prop.web')"
                        >{{ model.web }}</el-form-item>

                        <el-form-item
                            v-if="hasRoleToReadLogs"
                            :label="$t('status.created')"
                        >{{ model.created | formatDatetime }}</el-form-item>

                        <el-form-item
                            v-if="hasRoleToReadLogs"
                            :label="$t('status.modifiedAt')"
                        >{{ model.modified | formatDatetime }}</el-form-item>

                        <div class="button-group mt-3">
                            <el-button
                                v-if="hasRoleToUpdate"
                                icon="el-icon-fa-pencil-square-o"
                                @click="edit()"
                                type="primary"
                            >{{$t('table.edit')}}</el-button>
                            <el-button
                                v-if="hasRoleToReadLogs"
                                icon="el-icon-fa-history"
                                @click="history()"
                                type="infor"
                            >{{$t('table.history')}}</el-button>
                            <el-button
                                v-if="hasRoleToDelete"
                                icon="el-icon-fa-trash"
                                @click="destroy()"
                                type="danger"
                            >{{$t('table.delete')}}</el-button>
                        </div>
                    </el-form>
                </el-col>
                <!-- Rigth -->
                <!-- <el-col :span="8">
                    <coach-list :tournamentId="model.id"></coach-list>
                </el-col>
                <el-col :span="8">
                    <tournament-list :tournamentId="model.id"></tournament-list>
                </el-col> -->
            </el-row>

        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
// import Tournament from "@/entities/tournament/tournament-list";

export default {
    name: "app-tournament-show",

    // components: {
    //     tournamentList: Tournament
    // },

    props: {
        id: String
    },

    created() {
        this.$store
            .dispatch("entities/tournament/detail", this.id)
            .catch(() => this.$router.push({ name: "tournamentList" }));
    },

    beforeRouteLeave(to, from, next) {
        this.$store.dispatch("entities/tournament/clear");
        next();
    },

    computed: {
        ...mapGetters({
            model: "entities/tournament/model",
            loading: "entities/tournament/loading",
            hasRoleToDelete: "entities/tournament/hasRoleToDelete",
            hasRoleToUpdate: "entities/tournament/hasRoleToUpdate",
            hasRoleToRead: "entities/tournament/hasRoleToRead",
            hasRoleToReadLogs: "entities/tournament/hasRoleToReadLogs",
            hasRoleToCreate: "entities/tournament/hasRoleToCreate",
            isMobile: "shared/isMobile",
            labelPosition: "shared/labelPosition",
            labelWidth: "shared/labelWidth"
        })
    },

    methods: {
        edit() {
            this.$router.push({
                name: "tournamentEdit",
                params: { id: this.id, previous: "show" }
            });
        },

        destroy() {
            this.$confirm("Are you sure?", "Confirm", {
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                type: "warning"
            })
                .then(() =>
                    this.$store.dispatch("entities/tournament/destroy", this.model)
                )
                .then(() => this.$router.go(-1))
                .catch(() => {});
        },

        history() {
            this.$router.push({
                name: "tournamentHistorySingle",
                params: { id: this.id }
            });
        }
    }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/entities/tournament/tournament-show.vue?497aeb00